<form [formGroup]="signupForm" class="w-100" method="post" (ngSubmit)="signup()">
<div class="container-fluid px-0">
  <div class="row  mx-0 my-0 h-100">
    <div class="col-12 px-0 d-flex justify-content-center">
      <div *ngIf="errorMessage" class="error-message">
        <pa-message [description]="errorMessage" [width]="771" (messageState)="messageState($event)"></pa-message>
      </div>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <div class="rectangle">
        <div class="col-12 px-0 d-flex">
          <label class="title">Üye Ol</label>
        </div>
        <div class="col-12 px-0 d-flex">
          <mat-form-field class="input-style-first">
            <mat-label>E-posta adresinizi girin</mat-label>
            <input formControlName="email"
                   matInput>
            <mat-error
              *ngIf="submitted && signupForm.controls.email.errors && signupForm.controls.email.errors">
              Hatalı e-posta adresi girdiniz.
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-12 px-0 d-flex">
          <mat-form-field class="input-style">
            <mat-label>6 haneli şifre belirleyin</mat-label>
            <input formControlName="pin"
                   type="password" pattern="[0-9]*" inputmode="numeric"
                   autocomplete="off"
                   minlength="6"
                   maxlength="6"
                   matInput
                   tbOnlyNumber>
            <mat-error
              *ngIf="submitted && signupForm.controls.pin.errors && signupForm.controls.pin.errors.required">
              6 haneli şifre belirleyin.
            </mat-error>
            <mat-error
              *ngIf="submitted && signupForm.controls.pin.errors && signupForm.controls.pin.errors.minlength">
              Belirlediğiniz şifre 6 haneli olmalı.
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-12 px-0 d-flex">
          <mat-form-field class="input-style">
            <mat-label>Belirlediğiniz şifreyi doğrulayın</mat-label>
            <input formControlName="repin"
                   type="password" pattern="[0-9]*" inputmode="numeric"
                   autocomplete="off"
                   minlength="6"
                   maxlength="6"
                   matInput
                   tbOnlyNumber>
            <mat-error
              *ngIf="submitted && signupForm.controls.repin.errors.required">
              6 haneli yeni şifrenizi doğrulayın.
            </mat-error>
            <mat-error
              *ngIf="signupForm.controls.repin.hasError('notSame')">
              Hatalı şifre girdiniz.
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-12 px-0 d-flex">
          <div class="information d-flex">
            <div>
              <img class="info" [src]="'assets/images/info.png'" [srcset]="'assets/images/info@2x.png 2x, assets/images/info@3x.png 3x'" alt="logo">
            </div>
            <div>
              <label class="text-style">Şifreniz 6 rakamdan oluşmalı, artan veya azalan ardışık rakamlardan oluşmamalıdır. Belirlediğiniz şifreyi Paycell uygulamasına giriş yaparken de kullanacaksınız.</label>
              <label class="text-style" *ngIf="isLoginWebSdk">{{this.textService.keyValueMapping('finansmanInfo', 'Gsm bilginiz Turkcell Finansman A.Ş ile paylaşılacaktır.', this.sdkInitTexts)}}</label>
            </div>
          </div>
        </div>
        <div class="col-12 px-0 d-flex checkbox-div-first" *ngIf="showKvkk">
          <mat-checkbox class="checkbox-style" formControlName="kvkkAgreement" (change)="isShowAgreements()"><label class="checkbox-description" (click)="createAccountKvkkModal()">Kişisel Verilerin
            İşlenmesine ilişkin <span class="text-style">açık rıza metnini</span>
            onaylıyorum.</label></mat-checkbox>
        </div>
        <div class="col-12 px-0 d-flex" *ngIf="showEtk">
          <mat-checkbox class="checkbox-style" formControlName="etkAgreement"><label class="checkbox-description" (click)="createAccountEtkModal()">Fırsatlardan
            haberdar olmak için <span class="text-style">Elektronik Ticari İleti İzni</span>'ni
            onaylıyorum.</label></mat-checkbox>
        </div>
        <div class="col-12 px-0 d-flex" *ngIf="showEula">
          <mat-checkbox class="checkbox-style" formControlName="eulaAgreement" (change)="isShowAgreements()"><label class="checkbox-description" (click)="createAccountEulaModal()"><span
            class="text-style">TÖHAŞ Çerçeve Ödeme Hizmeti ve Elektronik Para Sözleşmesi</span>
            ve <span class="text-style">Uygulama Kullanım Sözleşmesi</span> 'ni kabul ediyorum.</label>
          </mat-checkbox>
        </div>
        <div class="col-12 d-flex button-div">
          <button type="submit"
                  [disabled]="signupForm.invalid"
                  [ngClass]="(signupForm.valid) ? 'button-style':'button-style-passive'"
          ><span class="text-style">{{buttonName}}</span></button>
        </div>
      </div>
    </div>
  </div>
</div>
</form>
